export default "__VITE_ASSET__NQ9$Kfhh__"